import React, { useState, useEffect } from "react";
import Constants from "../Utilities/Constants";
import axios from "axios";

const Invoice = ({ invoiceId }) => {
    const [pdfUrl, setPdfUrl] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        async function getInvoice() {
            const url = `${Constants.API_URL_GET_INVOICE}/${invoiceId}`;
            console.log(url);
            try {
                const response = await axios.get(url, { responseType: "blob" });
                const blob = new Blob([response.data], { type: "application/pdf" });
                setPdfUrl(URL.createObjectURL(blob));
            } catch (err) {
                console.log(err.message);
                setError(true);
            }
        }

        getInvoice();

        return () => {
            if (pdfUrl) URL.revokeObjectURL(pdfUrl);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (error) return <h3 className="m-4 text-center">חשבונית לא נמצאת</h3>;
    if (!pdfUrl) return <h3 className="m-4 text-center">טוען חשבונית...</h3>;

    return (
        <iframe
            src={pdfUrl}
            title="חשבונית"
            style={{ width: "100%", height: "90vh", border: "none" }}
        />
    );
};

export default Invoice;
